<div class="gridclass" [hidden]="editface">
  <gridview  class="block"
          [config]="config"
          [title]="title"
          [img]="img"
          pk='CODEPRODUCT'
          [tableName]="table_name"
          name="Cadastro de Produtos"
          (rowContext)="clickedRow($event)"
          [hidden]="editface"
          [options]="options"
          [cardcustom]="cardcontent"
          [cardsubtitle]="cardsubtitle"
          [columns]="columns"
          [addButtonAction]="openEditDialog">
  </gridview>
</div>
<div class="view-component"  *ngIf="editface">
    <div class="view-component-title">
      <div class="config">
        <button nz-button nzType="text" nzShape="circle" nz-tooltip="Voltar para a lista" (click)="editface=false">
          <nz-icon nzType="arrow-left"></nz-icon>
        </button>
      </div>
      <span *ngIf="editface" class="title">{{row.linha['CODEPRODUCT']}} - {{row.linha['NAME']}}</span>
    </div>
    <div class="content">
        <div class="tabcontent">
          <marketplace-tabs [parentRow]="row"></marketplace-tabs>
        </div>
    </div>
</div>

<ng-template #cardcontent let-item>

    <ng-container *ngFor="let dataitem of getData(item); trackBy: trackDataItem">
      @if( dataitem?.quantity > 0){
        <nz-badge [nzCount]="dataitem.quantity > 1 ? dataitem.quantity : 0" class="data-image-container">
          <div class="data-imagem" [nz-tooltip]="dataitem.name">
            <generic-icon [iconName]="dataitem.logo" type="custom"></generic-icon>
          </div>
        </nz-badge>
      }
      
    </ng-container>

</ng-template>


<ng-template #cardsubtitle let-item>
  <div class="subtitle">
    {{item['linha']['CODECONTRACT']}} - {{item['linha']['FK_MKTPPRODUCTS_MKTPCONTRACT->CONTRACTNAME']}}
  </div>
</ng-template>
